<header
  class="sticky top-0 flex w-full bg-white border-gray-200 z-99999 dark:border-gray-800 dark:bg-gray-900 xl:border-b">
  <div class="flex flex-col items-center justify-between grow xl:flex-row xl:px-6">
    <div
      class="flex items-center justify-between w-full gap-2 px-3 py-3 border-b border-gray-200 dark:border-gray-800 sm:gap-4 xl:justify-normal xl:border-b-0 xl:px-0 lg:py-4">
      <button
        class="items-center justify-center  w-10 h-10 text-gray-500 border-gray-200 rounded-lg z-99999 dark:border-gray-800 flex dark:text-gray-400 lg:h-11 lg:w-11 xl:border"
        [ngClass]="{
          'bg-gray-100 dark:bg-white/[0.03]': isMobileOpen$ | async
        }"
        (click)="handleToggle()" aria-label="Toggle Sidebar">
        @if (isMobileOpen$ | async) {
          <!-- Cross Icon -->
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M6.21967 7.28131C5.92678 6.98841 5.92678 6.51354 6.21967 6.22065C6.51256 5.92775 6.98744 5.92775 7.28033 6.22065L11.999 10.9393L16.7176 6.22078C17.0105 5.92789 17.4854 5.92788 17.7782 6.22078C18.0711 6.51367 18.0711 6.98855 17.7782 7.28144L13.0597 12L17.7782 16.7186C18.0711 17.0115 18.0711 17.4863 17.7782 17.7792C17.4854 18.0721 17.0105 18.0721 16.7176 17.7792L11.999 13.0607L7.28033 17.7794C6.98744 18.0722 6.51256 18.0722 6.21967 17.7794C5.92678 17.4865 5.92678 17.0116 6.21967 16.7187L10.9384 12L6.21967 7.28131Z"
              fill="currentColor" />
          </svg>
        } @else {
          <!-- Hamburger Icon -->
          <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M0.583252 1C0.583252 0.585788 0.919038 0.25 1.33325 0.25H14.6666C15.0808 0.25 15.4166 0.585786 15.4166 1C15.4166 1.41421 15.0808 1.75 14.6666 1.75L1.33325 1.75C0.919038 1.75 0.583252 1.41422 0.583252 1ZM0.583252 11C0.583252 10.5858 0.919038 10.25 1.33325 10.25L14.6666 10.25C15.0808 10.25 15.4166 10.5858 15.4166 11C15.4166 11.4142 15.0808 11.75 14.6666 11.75L1.33325 11.75C0.919038 11.75 0.583252 11.4142 0.583252 11ZM1.33325 5.25C0.919038 5.25 0.583252 5.58579 0.583252 6C0.583252 6.41421 0.919038 6.75 1.33325 6.75L7.99992 6.75C8.41413 6.75 8.74992 6.41421 8.74992 6C8.74992 5.58579 8.41413 5.25 7.99992 5.25L1.33325 5.25Z"
              fill="currentColor" />
          </svg>
        }
      </button>
      <!-- Logo (placeholder) -->
      <a routerLink="/" class="xl:hidden">
        <img class="dark:hidden max-w-40" src="/images/logo/logo.svg" alt="Logo" />
        <img class="hidden dark:block max-w-40" src="/images/logo/logo-dark.svg" alt="Logo" />
      </a>
      <button (click)="toggleApplicationMenu()"
        class="flex items-center justify-center w-10 h-10 text-gray-700 rounded-lg z-99999 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 xl:hidden">
        <!-- Dots Icon -->
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M5.99902 10.4951C6.82745 10.4951 7.49902 11.1667 7.49902 11.9951V12.0051C7.49902 12.8335 6.82745 13.5051 5.99902 13.5051C5.1706 13.5051 4.49902 12.8335 4.49902 12.0051V11.9951C4.49902 11.1667 5.1706 10.4951 5.99902 10.4951ZM17.999 10.4951C18.8275 10.4951 19.499 11.1667 19.499 11.9951V12.0051C19.499 12.8335 18.8275 13.5051 17.999 13.5051C17.1706 13.5051 16.499 12.8335 16.499 12.0051V11.9951C16.499 11.1667 17.1706 10.4951 17.999 10.4951ZM13.499 11.9951C13.499 11.1667 12.8275 10.4951 11.999 10.4951C11.1706 10.4951 10.499 11.1667 10.499 11.9951V12.0051C10.499 12.8335 11.1706 13.5051 11.999 13.5051C12.8275 13.5051 13.499 12.8335 13.499 12.0051V11.9951Z"
            fill="currentColor" />
        </svg>
      </button>
      <div class="hidden xl:block">
        <div class="relative">
          <span class="absolute -translate-y-1/2 pointer-events-none left-4 top-1/2">
            <!-- Search Icon -->
            <svg class="fill-gray-500 dark:fill-gray-400" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.04175 9.37363C3.04175 5.87693 5.87711 3.04199 9.37508 3.04199C12.8731 3.04199 15.7084 5.87693 15.7084 9.37363C15.7084 12.8703 12.8731 15.7053 9.37508 15.7053C5.87711 15.7053 3.04175 12.8703 3.04175 9.37363ZM9.37508 1.54199C5.04902 1.54199 1.54175 5.04817 1.54175 9.37363C1.54175 13.6991 5.04902 17.2053 9.37508 17.2053C11.2674 17.2053 13.003 16.5344 14.357 15.4176L17.177 18.238C17.4699 18.5309 17.9448 18.5309 18.2377 18.238C18.5306 17.9451 18.5306 17.4703 18.2377 17.1774L15.418 14.3573C16.5365 13.0033 17.2084 11.2669 17.2084 9.37363C17.2084 5.04817 13.7011 1.54199 9.37508 1.54199Z"
                fill="" />
            </svg>
          </span>
          <input
            #searchInput
            type="text"
            placeholder="Escribe para buscar…"
            autocomplete="off"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-200 bg-transparent py-2.5 pl-12 pr-14 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-800 dark:bg-gray-900 dark:bg-white/[0.03] dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 xl:w-[430px]"
            (input)="onSearch($any($event.target).value)"
            (keydown.enter)="selectFirstSearchItem()"
            (blur)="closeSearchDropdown()"
          />
          <button
            class="absolute right-2.5 top-1/2 inline-flex -translate-y-1/2 items-center gap-0.5 rounded-lg border border-gray-200 bg-gray-50 px-[7px] py-[4.5px] text-xs -tracking-[0.2px] text-gray-500 dark:border-gray-800 dark:bg-white/[0.03] dark:text-gray-400">
            <span> ⌘ </span>
            <span> K </span>
          </button>

          <!-- Search Dropdown -->
          @if (showSearchDropdown) {
            <div class="absolute left-0 top-full mt-1 w-full rounded-xl border border-gray-200 bg-white shadow-lg dark:border-gray-800 dark:bg-gray-900 z-[99999] max-h-72 overflow-y-auto">
              @if (filteredSearchItems.length === 0) {
                <p class="px-4 py-3 text-sm text-gray-400 dark:text-gray-500">Sin resultados para "{{ searchQuery }}"</p>
              } @else {
                <ul class="py-1">
                  @for (item of filteredSearchItems; track item.path) {
                    <li>
                      <button
                        class="flex w-full items-center gap-3 px-4 py-2.5 text-left menu-item-icon-inactive"
                        (mousedown)="selectSearchItem(item.path)">
                        <ng-icon [name]="item.icon" class="shrink-0 text-lg text-gray-400 dark:text-gray-500" />
                        <div class="min-w-0">
                          <p class="truncate text-sm font-medium text-gray-800 dark:text-white">{{ item.name }}</p>
                          <p class="truncate text-xs text-gray-400 dark:text-gray-500">{{ item.group }}</p>
                        </div>
                      </button>
                    </li>
                  }
                </ul>
              }
            </div>
          }
        </div>
      </div>
    </div>
    <div [ngClass]="isApplicationMenuOpen ? 'flex' : 'hidden'"
      class="items-center justify-between w-full gap-4 px-5 py-4 xl:flex shadow-theme-md xl:justify-end xl:px-0 xl:shadow-none">
      <div class="flex items-center gap-2 2xsm:gap-3">
        <!-- Command Palette Button -->
        <button (click)="toggleCommandPalette()"
          class="flex items-center justify-center w-10 h-10 text-gray-500 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 dark:text-gray-400"
          aria-label="Atajos de teclado" title="Atajos de teclado">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <rect x="2" y="4" width="16" height="12" rx="2" stroke="currentColor" stroke-width="1.5"/>
            <path d="M5 8h2M9 8h2M13 8h2M6 11h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
        <!-- Theme Toggle -->
        <button (click)="toggleTheme()"
          class="flex items-center justify-center w-10 h-10 text-gray-500 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 dark:text-gray-400"
          aria-label="Toggle Theme">
          <svg class="dark:hidden" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"/>
          </svg>
          <svg class="hidden dark:block" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"/>
          </svg>
        </button>
      </div>
      <!-- UserDropdown placeholder -->
      <app-user-dropdown />
    </div>
  </div>
</header>

<!-- Command Palette Modal -->
@if (showCommandPalette) {
  <div class="fixed inset-0 z-[99999] flex items-start justify-center pt-24">
    <div class="absolute inset-0" (click)="closeCommandPalette()"></div>
    <div class="relative w-full max-w-sm rounded-2xl border border-gray-200 bg-white shadow-2xl dark:border-gray-800 dark:bg-gray-900"
      [style.transform]="'translate(' + dragX + 'px, ' + dragY + 'px)'"
      [class.transition-none]="isDragging">
      <!-- Header (drag handle) -->
      <div class="flex items-center justify-between border-b border-gray-200 px-5 py-3 dark:border-gray-800 cursor-move select-none"
        (mousedown)="onPaletteDragStart($event)">
        <h3 class="text-sm font-semibold text-gray-800 dark:text-white">Atajos de teclado</h3>
        <button (click)="closeCommandPalette()" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
          <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
            <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <!-- Commands list -->
      <div class="px-5 py-3">
        <ul class="space-y-2">
          @for (cmd of commands; track cmd.key) {
            <li class="flex items-center justify-between rounded-lg px-3 py-2 hover:bg-gray-50 dark:hover:bg-white/5">
              <div>
                <p class="text-sm font-medium text-gray-800 dark:text-white">{{ cmd.label }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">{{ cmd.description }}</p>
              </div>
              <span class="inline-flex items-center gap-1">
                @for (part of cmd.key.split(' '); track part) {
                  <kbd class="rounded border border-gray-200 bg-gray-50 px-1.5 py-0.5 text-xs font-mono text-gray-600 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">{{ part }}</kbd>
                }
              </span>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
}